import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { hsl } from 'd3-color';

export default class Swatches extends PureComponent {
  render() {
    const { color, onClick, padLeft, swatches } = this.props;
    const size = '13px';
    const sw = swatches.filter(s => !!s).sort(compareColors);
    return sw && sw.length ? (
      <div
        className={classnames('d-flex wrap align-end', { 'ml-10': padLeft })}
      >
        {sw.map(swatch => (
          <div
            key={swatch}
            className={classnames('d-ib swatch rounded pointer border-box', {
              'swatch--active': swatch.toUpperCase() === color.toUpperCase(),
            })}
            style={{
              backgroundColor: swatch,
              width: size,
              height: size,
            }}
            onClick={() => onClick(swatch)}
          />
        ))}
      </div>
    ) : null;
  }
}

// sort by hue, then luminance. if hue is within 30,
const compareColors = (a, b) => {
  const { h: ha, s: sa, l: la } = hsl(a);
  const { h: hb, s: sb, l: lb } = hsl(b);
  // sort by luminosity
  // return la - lb;

  // sort by combined luminosity and saturation
  // return (la - sa) - (lb - sb);

  // sort by hue, then combined lum and sat
  return Math.abs(ha - hb) < 1 ? la + sa - (lb + sb) : ha - hb;

  // return Math.abs(ha - hb) <= 5
  //   ? lb - la
  //   : ha - hb;
  // return Math.abs(sa - sb) < 10
  //   ? ha - hb
  //   : sa - sb;
};
